// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__W_Y-R","rest":"footer_rest__1l7Qf","social":"footer_social__2UccP","brand":"footer_brand__1lCsG","help":"footer_help__W06TL"};